<template>
  <div class="solution-content">
    <div class="common-title">
      <div class="common-title-content">
        方案概述
      </div>
    </div>
    <p class="solution-info">
      对园区全要素进行管理，实现辖区人、车、物等信息的直接和间接关联与查询，对园区内涉及重点人员、车辆进行实时监控，对园区内的异常行为、动作进行实时分析并生成异常分析报告，为园区管理者、园区民警工作提供靶向性管理目标，指导管理者开展日常工作。
    </p>
    <div class="solution-des">
      <img src="@/assets/images/solution/img_zhyq.png" />
    </div>
    <div class="solution-main-function">
      <div class="common-title">
        <div class="common-title-content">
          主要功能
        </div>
      </div>
      <div class="solution-main-show">
        <div class="show-item" v-for="(item, index) in iconList" :key="index">
          <img :src="item.iconSrc" />
          <div class="text">{{ item.text }}</div>
        </div>
      </div>
    </div>
    <div class="solution-application-scene">
      <div class="common-title">
        <div class="common-title-content">
          应用场景
        </div>
      </div>
      <div class="show-scene-list">
        <div class="item" v-for="(item, index) in imgList" :key="index">
          <img :src="item.imgUrl" />
          <div class="text">{{ item.text }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "zhsq",
  data() {
    return {
      iconList: [
        {
          iconSrc: require("@/assets/images/solution/ico_cjbk.png"),
          text: "场景布控"
        },
        {
          iconSrc: require("@/assets/images/solution/ico_rygl.png"),
          text: "人员管理"
        },
        {
          iconSrc: require("@/assets/images/solution/ico_yjyc.png"),
          text: "预警预测"
        },
        {
          iconSrc: require("@/assets/images/solution/ico_zypz.png"),
          text: "资源配置"
        },
        {
          iconSrc: require("@/assets/images/solution/ico_ypbg.png"),
          text: "研判报告"
        }
      ],
      imgList: [
        {
          imgUrl: require("@/assets/images/solution/qyld.png"),
          text: "企业联动"
        },
        {
          imgUrl: require("@/assets/images/solution/ymtx.png"),
          text: "一码通行"
        },
        {
          imgUrl: require("@/assets/images/solution/zsyz.png"),
          text: "招商引资"
        },
        {
          imgUrl: require("@/assets/images/solution/ggyy.png"),
          text: "广告运营"
        }
      ]
    };
  }
};
</script>
